<!-- workers-list.component.html -->

<div class="wl">

  <!-- ── Page Header ─────────────────────────────── -->
  <div class="wl__header">
    <div class="wl__header-left">
      <h1 class="wl__title">Workers</h1>
      <p class="wl__subtitle">Manage and monitor all registered field workers.</p>
    </div>
    <div class="wl__header-right">
      <div class="wl__search-wrap">
        <svg class="wl__search-icon" width="15" height="15" viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.8"/>
          <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        <input
          class="wl__search"
          type="text"
          placeholder="Search workers…"
          [(ngModel)]="searchQuery"
          (input)="onSearch()"
        />
      </div>
      <a routerLink="/invite-worker" class="wl__invite-btn">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
          <path d="M16 21V19C16 16.8 14.2 15 12 15H5C2.8 15 1 16.8 1 19V21"
                stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <circle cx="8.5" cy="7" r="4" stroke="currentColor" stroke-width="1.8"/>
          <line x1="20" y1="8" x2="20" y2="14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <line x1="17" y1="11" x2="23" y2="11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        Invite Worker
      </a>
    </div>
  </div>

  <!-- ── Summary Chips ───────────────────────────── -->
  <div class="wl__chips">
    <div class="wl__chip">
      <span class="wl__chip-dot wl__chip-dot--all"></span>
      <span class="wl__chip-label">Total</span>
      <span class="wl__chip-val">{{ workers.length }}</span>
    </div>
    <div class="wl__chip">
      <span class="wl__chip-dot wl__chip-dot--online"></span>
      <span class="wl__chip-label">Online</span>
      <span class="wl__chip-val">{{ onlineCount }}</span>
    </div>
    <div class="wl__chip">
      <span class="wl__chip-dot wl__chip-dot--offline"></span>
      <span class="wl__chip-label">Offline</span>
      <span class="wl__chip-val">{{ workers.length - onlineCount }}</span>
    </div>
  </div>

  <!-- ── Table Card ──────────────────────────────── -->
  <div class="wl__card">

    <!-- Loading -->
    <div class="wl__loading" *ngIf="loading">
      <div class="wl__spinner"></div>
      <span>Loading workers…</span>
    </div>

    <!-- Table -->
    <div class="wl__table-wrap" *ngIf="!loading">

      <!-- Empty state -->
      <div class="wl__empty" *ngIf="filteredWorkers.length === 0">
        <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
          <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.4"/>
          <path d="M2 20C2 17 5 14 9 14" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
          <path d="M16 14C19.3 14 22 16.7 22 20" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
          <circle cx="17" cy="10" r="3" stroke="currentColor" stroke-width="1.4"/>
        </svg>
        <p>{{ searchQuery ? 'No workers match your search.' : 'No workers registered yet.' }}</p>
        <a routerLink="/invite-worker" class="wl__empty-cta">Invite your first worker</a>
      </div>

      <table class="wl__table" *ngIf="filteredWorkers.length > 0">
        <thead>
          <tr>
            <th class="wl__th wl__th--worker">Worker</th>
            <th class="wl__th">Email</th>
            <th class="wl__th wl__th--center">Status</th>
            <!-- <th class="wl__th wl__th--center">Actions</th> -->
          </tr>
        </thead>
        <tbody>
          <tr class="wl__row" *ngFor="let worker of pagedWorkers">

            <!-- Worker cell -->
            <td class="wl__td">
              <div class="wl__worker-cell">
                <div class="wl__avatar" [style.background]="getAvatarColor(worker.fullName)">
                  {{ getInitials(worker.fullName) }}
                </div>
                <div class="wl__worker-info">
                  <span class="wl__worker-name">{{ worker.fullName }}</span>
                  <!-- <span class="wl__worker-id">ID: {{ worker.id || '—' }}</span> -->
                </div>
              </div>
            </td>

            <!-- Email -->
            <td class="wl__td">
              <a class="wl__email-link" href="mailto:{{ worker.email }}">
                {{ worker.email }}
              </a>
            </td>

          

            <!-- Status -->
            <td class="wl__td wl__td--center">
              <span class="wl__status"
                    [class.wl__status--online]="worker.isOnline"
                    [class.wl__status--offline]="!worker.isOnline">
                <span class="wl__status-dot"></span>
                {{ worker.isOnline ? 'Online' : 'Offline' }}
              </span>
            </td>

            <!-- Actions -->
            <!-- <td class="wl__td wl__td--center">
              <div class="wl__actions">
                <button class="wl__action-btn wl__action-btn--view"
                        title="View profile"
                        [routerLink]="['/workers', worker.id]">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z"
                          stroke="currentColor" stroke-width="1.8"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.8"/>
                  </svg>
                </button>
                <button class="wl__action-btn wl__action-btn--message"
                        title="Send message">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
                          stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </td> -->

          </tr>
        </tbody>
      </table>

      <!-- Pagination -->
      <div class="wl__pagination" *ngIf="totalPages > 1">
        <span class="wl__pagination-info">
          Showing {{ (currentPage - 1) * pageSize + 1 }}–{{ Math.min(currentPage * pageSize, filteredWorkers.length) }}
          of {{ filteredWorkers.length }} workers
        </span>
        <div class="wl__pagination-controls">
          <button class="wl__page-btn"
                  (click)="goToPage(currentPage - 1)"
                  [disabled]="currentPage === 1">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>

          <button class="wl__page-btn wl__page-btn--num"
                  *ngFor="let p of pageNumbers"
                  [class.wl__page-btn--active]="p === currentPage"
                  (click)="goToPage(p)">
            {{ p }}
          </button>

          <button class="wl__page-btn"
                  (click)="goToPage(currentPage + 1)"
                  [disabled]="currentPage === totalPages">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

    </div>
  </div>
</div>